import * as THREE from 'three';
import {TWEEN} from "three/examples/jsm/libs/tween.module.min";

export class PlayerHandler {

	//Added objects to the scene
	addedPlayers = {}

	tweens = {}

	localPlayer = null

	localTarget = null

	/**
	 * Mapping of device type -> the sprite model to use as their player
	 * @type {{"1": string, "2": string, "4": string, "6": string}}
	 */
	deviceModelMap = {
		1: "player", //3D Sprite
		2: "mocap", //AR
		4: "observer", //Observer
		6: "player", //3rd Person
	}

	modelScaleMap = {
		"default_sprite": [1, 1, 1],
		"custom_sprite": [1.5, 1.5, 1.5]
	}

	constructor(modelManager, positionManager) {
		this.modelManager = modelManager
		this.positionManager = positionManager
	}

	frame = 0

	update() {
		if (this.localPlayer && this.frame % 15) {
			const players = Object.keys(this.addedPlayers)

			for (let i = 0; i < players.length; i++) {
				const selectedPlayer = this.addedPlayers[players[i]]

				if (this.euclideanDistance(this.localPlayer, selectedPlayer) < 25) {
					selectedPlayer.addLabel()
				} else {
					selectedPlayer.removeLabel()
				}
			}
		}

		TWEEN.update()
		this.frame++
		if (this.frame > 10000) this.frame = 0
	}

	euclideanDistance(player1, player2) {

		const pos1 = player1.position
		const pos2 = player2.position

		return Math.sqrt((pos1.x - pos2.x) * (pos1.x - pos2.x) + (pos1.z - pos2.z) * (pos1.z - pos2.z))
	}

	/**
	 * Sets the scale of a given player model
	 *
	 * @param model
	 * @param scale
	 */
	setModelScale(model, scale) {
		this.modelScaleMap[model] = [scale.x, scale.y, scale.z]
	}

	setDeviceModel(deviceType, model) {
		this.deviceModelMap[this.deviceTypeToId(deviceType)] = model
	}

	handlePlayerEntityAdd(player, isLocal = false) {
		if (this.addedPlayers[player.uid]) {
			console.log("Player already added: ", player);
			return
		}

		console.log("PlayerHandler::handlePlayerEntityAdd", player);
		player.local = isLocal;

		if (isLocal) {
			this.localPlayer = player
		}

		//Update our added list
		this.addedPlayers[player.uid] = player;

		//Add to position manager
		this.positionManager.add(player);
		this.positionManager.setDevicePosition(player.uid);

	}

	/**
	 * @deprecated - use handlePlayerEntityAdd instead
	 * @param player
	 * @param scene
	 * @param isLocal
	 */
	handlePlayerAdd(player, scene, isLocal = false) {
		if (this.addedPlayers[player.uid]) {
			console.log("Player already added: ", player);
			return
		}

		player.local = isLocal;
		player.cube = new THREE.Group();
		player.cube.name = player.uid;

		const playerModel = this.deviceModelMap[player.device_type]
		const obj = this.modelManager.getModel(playerModel).clone()


		console.log("adding player to scene: ", {
			player: player,
			local: isLocal,
			modelKey: playerModel,
			model: obj
		});
		player.cube.add(obj)

		if (player.local) {
			this.localPlayer = player
		}

		console.log("Adding to scene: ", player.cube);
		scene.add(player.cube);

		//Update our added list
		this.addedPlayers[player.uid] = player;

		//Add to position manager
		this.positionManager.add(player);
		this.positionManager.setDevicePosition(player.uid);
	}

	handlePlayerRemove(uid, scene) {
		console.log("Attempting to remove player from scene: ", uid);

		if (!this.addedPlayers[uid]) {
			console.log("Player not in players array: ", uid);
			return
		}

		let selectedObject = scene.getObjectByName(uid);
		if (this.addedPlayers[uid].cube)
			this.addedPlayers[uid].cube.removeFromParent();

		if (this.addedPlayers[uid])
			this.addedPlayers[uid].remove()

		console.log("Removed: ", {
			uid: uid,
			selectedObject: selectedObject,
			added: this.addedPlayers[uid].cube
		});

		scene.remove(selectedObject);
		scene.remove(uid);

		delete this.addedPlayers[uid];
		delete this.positionManager.players[uid]; //TODO

		console.log("Entities: ", scene.getChildren());
	}

	handlePlayerMove(data) {
		// console.log("handlePlayerMove", {
		//     data: data,
		//     player: this.positionManager.players[data.player_uid],
		// })

		// if (!this.positionManager.players[data.player_uid]) {
		//     console.warn("Player not in positionManager array", data.player_uid)
		// }

		// const deviceType = this.positionManager.players[data.player_uid].device_type

		if (this.localPlayer !== null && data.player_uid === this.localPlayer.uid) {
			// console.log("Updating player local target", data.position);
			// this.localTarget.visible = true;
			// this.localTarget.position.set(data.position.x, data.position.y, data.position.z)
			return
		}

		this._handlePlayerMove(data)
	}

	isLocalMove(uid) {
		return uid === this.localPlayer.uid
	}

	createLocalTarget(scene) {
		const geometry = new THREE.SphereGeometry(0.1, 32, 16);
		const material = new THREE.MeshBasicMaterial({color: "red"});
		this.localTarget = new THREE.Mesh(geometry, material);

		scene.add(this.localTarget);
		this.localTarget.visible = false; //Hide until player moves

		console.log("Added sphere", this.localTarget)
	}

	_handlePlayerMove(data) {
		if (!this.addedPlayers[data.player_uid]) {
			console.log(`${data.player_uid} - Player not in players array: `, data);
			return false
		}

		if (!data.rotation) {
			console.log(`${data.player_uid} - No rotation data: `, data);
			data.rotation = {x: 0, y: 0, z: 0}
		}

		const speed = 0.03;
		const deviceType = this.positionManager.players[data.player_uid].device_type

		//Bind player to the floor and rotation if in 3D mode
		if (deviceType === 1 || deviceType === 6) {
			//Pos
			// data.position.y = 0;
			//Rot
			data.rotation.x = 0;
			data.rotation.z = 0;
		}


		// console.log("Setting offset", data)
		this.positionManager.players[data.player_uid].setOffset(data);
		// this.positionManager.updatePosition(data.player_uid, data, speed);

		//TODO Tween
		if (deviceType === 4) {
			this.teleportPosition(data.player_uid, data.rotation) //Set our position
		} else {
			this.tweenPosition(data.player_uid, speed)
		}

		let r = data.rotation;
		if (r !== undefined) {
			// if (this.positionManager.players[data.player_uid].obj)
			//     this.positionManager.players[data.player_uid].obj.rotation.set(0, this.degToRad(r.y), 0)

			if (this.positionManager.players[data.player_uid].cube)
				this.positionManager.players[data.player_uid].cube.rotation.set(this.degToRad(r.z), this.degToRad(r.y), this.degToRad(r.x))
		}
	}

	degToRad(degrees) {
		return degrees * (Math.PI / 180);
	}


	teleportPosition(uid, rotation = undefined) {
		const plr = this.positionManager.players[uid];
		if (!plr) {
			console.error("PlayerHandler::teleportPosition - Player not found: ", uid);
		}

		const target = plr.getAbsolutePosition()
		// plr.obj.position.set(target.x, target.y, target.z);
		if (rotation === undefined)
			plr.obj.lookAt(new THREE.Vector3(target.x,
				target.y,
				target.z))
		else {
			plr.obj.rotation.set(rotation.x, rotation.y, rotation.z)
		}

		this.tweens[uid] = new TWEEN.Tween(plr.obj.position).to({
			x: target.x,
			y: target.y,
			z: target.z
		}, 200).easing(TWEEN.Easing.Linear.None).onComplete(() => {
			plr.stopAnimation("walk")
		}).start();
	}

	tweenPosition(uid, speed = 0.02) {
		const plr = this.positionManager.players[uid];
		if (!plr) {
			console.error("PlayerHandler::tweenPosition - Player not found: ", uid);
		}

		if (!plr.obj)
			return //Player obj not yet instantiated

		// const target = plr.getAbsolutePosition()
		const target = plr.position
		const dt = plr.obj.position.distanceTo(target)

		const moveTime = dt * (speed * 1000)  // 200ms per block

		// console.log("Tweening: ", {
		// 	uid: uid,
		// 	source: plr.obj.position,
		// 	target: target,
		// 	dt: dt,
		// 	speed: speed,
		// 	moveTime: moveTime
		// });

		if (this.tweens[uid])
			this.tweens[uid].stop()

		// if(target.y - plr.obj.position.y > 1) {
		// 	plr.playAnimation("jump")
		// } else {
			plr.playAnimation("walk")
		// }

		plr.obj.lookAt(new THREE.Vector3(target.x,
			// target.y,
			plr.obj.position.y, //Stop us from looking at the y when jumping
			target.z))

		this.tweens[uid] = new TWEEN.Tween(plr.obj.position).to({
			x: target.x,
			y: target.y,
			z: target.z
		}, 200).easing(TWEEN.Easing.Linear.None).onComplete(() => {
			plr.stopAnimation("walk")
			plr.stopAnimation("jump")
			plr.playAnimation("idle")
		}).start();
	}

	deviceTypeToId(dt) {
		switch (dt.toUpperCase()) {
			case "3D":
				return 1
			case "AR":
				return 2
			case "OBSERVER":
				return 4
			case "3D3RD":
			case "3DMOBILE":
				return 6
		}

		console.warn("Unknown device type: ", dt)
		return 1; //Default to 3D
	}

	reset() {
		this.addedPlayers = {}
		this.tweens = {}
		this.localPlayer = null
		this.localTarget = null
	}
}
